<script lang="ts">
	import { reveal } from '$lib/actions/reveal';
	import SectionHeading from '$lib/components/ui/SectionHeading.svelte';
	import type { PostMeta } from '$lib/blog/posts';
	import type { Author } from '$lib/blog/authors';

	let { posts, authors }: { posts: PostMeta[]; authors: Record<string, Author> } = $props();

	function formatDate(d: string) {
		return new Date(d).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		});
	}
</script>

{#if posts.length}
	<section class="mx-auto mt-20 max-w-[1280px] px-4 sm:mt-32 lg:mt-40 lg:px-0">
		<div class="reveal" use:reveal>
			<SectionHeading
				eyebrow="From the blog"
				title="Latest from the team."
				description="Technical deep dives, product updates, and operational lessons from running Linux fleets at scale."
			/>
		</div>
		<div
			class="stagger-children mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
			use:reveal
		>
			{#each posts as post (post.slug)}
				{@const author = authors[post.author]}
				<a
					href="/blog/{post.slug}/"
					class="enterprise-card group flex flex-col overflow-hidden rounded-2xl transition-all"
				>
					{#if post.cover}
						<div class="aspect-[16/9] w-full overflow-hidden bg-white/5">
							<img
								src={post.cover}
								alt=""
								class="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
								loading="lazy"
							/>
						</div>
					{/if}
					<div class="flex flex-1 flex-col p-6">
						<h3
							class="mb-2 font-display text-lg font-medium leading-snug text-white transition-colors group-hover:text-[var(--color-blue-soft)]"
						>
							{post.title}
						</h3>
						<p class="mb-5 flex-1 font-display text-sm text-white/55 line-clamp-2">
							{post.description}
						</p>
						<div class="font-display text-xs text-white/40">
							{author?.name ?? post.author} · {formatDate(post.date)} · {post.readingTime}
						</div>
					</div>
				</a>
			{/each}
		</div>
		<div class="reveal mt-10 flex justify-center" use:reveal>
			<a
				href="/blog/"
				class="btn-secondary inline-flex h-11 items-center justify-center rounded-md px-6 font-display text-sm font-medium"
			>
				View all posts
			</a>
		</div>
	</section>
{/if}
